import React, { useState } from "react";
import { Send, Loader2, Check } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const input = "w-full rounded-xl border border-border bg-background px-3 py-2 text-sm focus:border-primary focus:outline-none";
const EMPTY = { name: "", email: "", school: "", phone: "", message: "", website: "" };

export const TeacherEnquiryForm = () => {
  const [f, setF] = useState(EMPTY);
  const [state, setState] = useState("idle");
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault(); setState("busy");
    try { await api.post("/more/teacher-enquiry", f); setState("done"); toast.success("Thanks. Jason will reply soon."); }
    catch (err) { setState("idle"); const d = err.response?.data?.detail; toast.error(Array.isArray(d) ? d[0]?.msg : d || "Please check your details"); }
  };
  if (state === "done") return <p className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-primary" data-testid="teacher-enquiry-done"><Check size={16} /> Thanks. Jason will reply to you by email soon.</p>;
  return (
    <form onSubmit={submit} className="mt-5 grid gap-3 sm:grid-cols-2" data-testid="teacher-enquiry-form">
      <input required placeholder="Your name" value={f.name} onChange={set("name")} className={input} data-testid="teacher-enquiry-name" />
      <input required type="email" placeholder="Your email" value={f.email} onChange={set("email")} className={input} data-testid="teacher-enquiry-email" />
      <input required placeholder="School or organisation" value={f.school} onChange={set("school")} className={input} data-testid="teacher-enquiry-school" />
      <input placeholder="Phone (optional)" value={f.phone} onChange={set("phone")} className={input} data-testid="teacher-enquiry-phone" />
      <textarea required rows={4} placeholder="Your question, e.g. class size, instruments, start date" value={f.message} onChange={set("message")} className={`${input} sm:col-span-2`} data-testid="teacher-enquiry-message" />
      <input tabIndex={-1} autoComplete="off" value={f.website} onChange={set("website")} className="hidden" aria-hidden="true" />
      <button type="submit" disabled={state === "busy"} data-testid="teacher-enquiry-submit"
        className="inline-flex w-fit items-center gap-2 rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground disabled:opacity-60">
        {state === "busy" ? <Loader2 size={15} className="animate-spin" /> : <Send size={15} />} Send to Jason
      </button>
    </form>
  );
};
